import type { NiceModalHandler } from '@ebay/nice-modal-react'

export default function closeModal(modal: NiceModalHandler) {
  modal.hide()
  // Temporary fix because await modal.hide(); modal.remove() not working
  setTimeout(() => modal.remove(), 300)
}
